// What is happening to this video's files, shown by the tab rather than by the
// control that started it.
//
// The uploader panel and the replace dialog both unmount when you change tabs,
// and the replace dialog also unmounts when it is closed. Reading the store
// here means the progress is still on screen when you come back, whichever of
// them started it -- and that a finished upload says so instead of leaving the
// panel looking untouched.

import React from 'react';
import { Alert, Box, LinearProgress, Typography } from '@mui/material';
import { useAdmin, isUploadActive } from './AdminStore';

const SEVERITY = { done: 'success', error: 'error' };

export function UploadStatus({ identifier }) {
  const { uploads } = useAdmin();

  const mine = Object.entries(uploads)
    .filter(([, entry]) => entry.identifier === identifier)
    .sort(([a], [b]) => a.localeCompare(b));

  if (!mine.length) return null;

  return (
    <Box sx={{ mb: '18px' }}>
      {mine.map(([key, entry]) => (
        <Box key={key} sx={{ mb: '10px' }}>
          <span className="admin-label">
            {entry.kind} {isUploadActive(entry) ? 'upload' : 'upload — finished'}
          </span>
          <Typography
            className="admin-mono"
            sx={{ fontSize: 11, color: 'var(--ps-text-dim)', mt: '2px' }}
          >
            {entry.filename}
            {isUploadActive(entry) && ` · ${entry.progress}%`}
          </Typography>

          {isUploadActive(entry) && (
            <Box sx={{ mt: '4px' }}>
              <LinearProgress
                variant={entry.state === 'uploading' && entry.progress ? 'determinate' : 'indeterminate'}
                value={entry.progress}
                aria-label={`${entry.kind} upload progress`}
              />
              {/* Registering is short but it is not nothing: the record is read
                  back before it is patched, so a slow round trip here is the
                  difference between "done" and "done and saved". */}
              {entry.state === 'registering' && (
                <Typography sx={{ fontSize: 10.5, color: 'var(--ps-text-dim)', mt: '4px' }}>
                  Uploaded. Pointing the record at it…
                </Typography>
              )}
            </Box>
          )}

          {entry.message && (
            <Alert severity={SEVERITY[entry.state] || 'info'} sx={{ mt: '6px' }}>
              {entry.message}
            </Alert>
          )}
        </Box>
      ))}
    </Box>
  );
}

export default UploadStatus;
